import { Check, Close } from '@mui/icons-material';
import { Button, IconButton, Modal, Paper, Tooltip, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function FinishModal(props) {

    const {t} = useTranslation()

    const [timeAllowed, setTimeAllowed] = useState(true);
    const [changeAllowed, setChangeAllowed] = useState(true);

    const toggleTimeAllowed = () => {
        setTimeAllowed(!timeAllowed);
    }

    const toggleChangeAllowed = () => {
        setChangeAllowed(!changeAllowed);
    }

    return(
        <Modal
        open={props.open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
    >
        <Paper sx={{
            position: 'absolute',
            display: "flex",
            flexDirection: "column",
            alignItems: "left",
            width: "30rem",
            maxWidth: "90%",
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            p: 2
        }}>

                <Typography align="center" sx={{fontWeight: 500}}>{t("surveyModalText1")}</Typography>
                <hr/>
                <Typography>{t("surveyModalText2")}:</Typography>
                
            <Box sx={{m: 2}}>
                <UnchangableData text={t("surveyModalText3")}/>
                <ChangableData toggleAllowed={toggleTimeAllowed} allowed={timeAllowed} text={t("surveyModalText4")}/>
                <ChangableData toggleAllowed={toggleChangeAllowed} allowed={changeAllowed} text={t("surveyModalText5")}/>
                <Box sx={{display: "flex", justifyContent: "space-between", mt: 2}}>
                    <Button variant="contained" color="error" onClick={props.close}>{t("surveyModalButton1")}</Button>
                    <Button variant="contained" color="primary" onClick={() => props.handleFinish(changeAllowed, timeAllowed)}>{t("surveyModalButton2")}</Button>
                </Box>

            </Box>
        </Paper>
    </Modal>
    )
}

function ChangableData(props) {


    return(
        <Box>
            {
                props.allowed
                ?
                    <Box sx={{display: "flex", alignItems: "center"}}>
                        <IconButton color="primary" onClick={props.toggleAllowed} >
                            <Check/>
                        </IconButton>
                        <Typography>{props.text}</Typography>
                    </Box>
                :
                    <Box sx={{display: "flex", alignItems: "center"}}>
                        <IconButton color="error" onClick={props.toggleAllowed}>
                            <Close/>
                        </IconButton>
                        <Typography sx={{textDecoration:"line-through"}}>{props.text}</Typography>
                    </Box>
            }
        </Box>
    )
}

function UnchangableData(props) {

    return(
        <Box sx={{display: "flex", alignItems: "center"}}>
            <Tooltip title="Dieses Feld ist Pflicht" enterTouchDelay={0}>
                <IconButton color="primary">
                    <Check/>
                </IconButton>
            </Tooltip>
            <Typography>{props.text}</Typography>
        </Box>
    )
}